/* global moment */
export default class Event {
    /**
     * @param {Object} data - Raw event data from API
     */
    constructor(data) {
        if (!data.id) throw new Error('Event requires an id');
        if (!data.date) throw new Error('Event requires a date');

        this.id = Number(data.id);
        this.date = moment(data.date).format('MMM D, h:mma');
        this.start = moment(data.date);
        this.isStudent = Boolean(data.isStudent);
        this.isBlackout = Boolean(data.isBlackout);
        // Validate and normalize pricing data
        this.pricing = (Array.isArray(data.pricing) ? data.pricing : [])
            .map((item) => ({ section: String(item.section || ''), price: String(item.price || '') }))
            .filter((item) => item.section && item.price);
    }

    /**
     * Sorts events by start time
     * @param {Event} a
     * @param {Event} b
     * @returns {number}
     */
    static sortByStart(a, b) {
        return a.start - b.start;
    }
}
